import { useEffect, useRef, useState } from "react";
import { Spanish } from "flatpickr/dist/l10n/es.js"

declare const $: any;

function DatepickerComponent({
  type = "text",
  label,
  errors,
  sizeClass = "form-control-lg",
  onChange,
  value,
  mode = "single",
  disable = []
}: any) {
  const internalRef = useRef<any>();

  const [instance, setInstance] = useState<any>();
  

  useEffect(() => {
    const $instance = $(internalRef.current).flatpickr({
      locale: Spanish,
      mode,
      disable,
      onChange: (selectedDates: any, dateStr: any, instance: any) => {
        onChange(mode === 'single' ? dateStr: Object.values(selectedDates));
      },
    });
    setInstance($instance);
  }, [internalRef]);

  useEffect(() => {
    if(instance && !value) {
      instance.clear();
    }
  }, [value]);

  return (
    <>
      <label className="form-label">{label}</label>
      <div className={"input-group d-flex " + (errors ? "is-invalid" : "")}>
        <input
          type={type}
          ref={internalRef}
          className={
            "form-control " + sizeClass + (errors ? " is-invalid " : "")
          }
          value={value}
          onChange={() => {}}
        />

      <span className="input-group-text bg-light-danger pointer" onClick={() => onChange('')}>
        <i className="bi bi-x-lg text-danger"></i>
      </span>
      </div>
    </>
  );
}

export default DatepickerComponent;
